export default {
  "TextCopyright.Copyright": "© NTT DOCOMO, INC. All Rights Reserved.",
}
